import React, {
  Suspense,
  lazy,
  useEffect,
  useMemo,
  useState,
  useCallback,
} from "react";
import { makeStyles } from "@material-ui/styles";
import { Chip, Snackbar, TextField } from "@material-ui/core";
import Text from "../../components/Text";
import _ from "lodash";
import { getTaskInputs, getTasksListing } from "../../data/services/API";
import {
  generateRandomText,
  getTaskObj,
  updateTaskList,
} from "../../utils/helpers";
import "./taskStyles.css";
import { TASK_OPTIONS, TaskType } from "../../utils/constants";
import { Alert, Autocomplete } from "@material-ui/lab";
import ErrorBoundary from "../../data/ErrorBoundary";

const useStyles = makeStyles({
  container: {
    minHeight: "100%",
  },
  formContainer: {
    marginTop: "1rem",
  },
  header: { display: "flex", alignItems: "center" },
});

const TaskDefinationTab = (props) => {
  const tabClass = useStyles();
  const {
    tasks,
    setTasks,
    id,
    inputParameters,
    className,
    clickedWorkflowNodeTaskRef,
    setClickedWorkflowNodeTaskRef,
    changeTask,
    setIsNodeOnClickEnabled,
    setIsTaskDataLoading,
    setTaskData,
    taskData,
    clickedTask,
    setClickedTask,
    onModifiedJQ,
    onJsonErrors,
    setEditorDelay,
  } = props;

  // const [taskArrayForSelectListing, setTaskArrayForSelectListing] = useState(
  //   []
  // );
  const [taskArrayForSelectListing, setTaskArrayForSelectListing] = useState(
    TASK_OPTIONS
  );
  const [isComponentLoading, setIsComponentLoading] = useState(false);
  const [ComponentToRender, setComponentToRender] = useState("");
  const [inputFields, setInputFields] = useState([]);
  const [clickedTaskType, setClickedTaskType] = useState("");
  var [fileNotFound, setFileNotFound] = useState(false);
  var [customTaskNotFound, setCustomTaskNotFound] = useState(false);
  var [isExpanded, setIsExpanded] = useState(false);
  var [expandedSubWf, setExpandedSubWf] = useState({
    task: null,
    index: null,
    length: null,
  });

  const handleExpandChange = (vals, wfData) => {
    const addIsSubWF = (task) => {
      const modifiedTask = { ...task, isSubWF: true };
  
      if (modifiedTask.decisionCases) {
        Object.keys(modifiedTask.decisionCases).forEach((key) => {
          modifiedTask.decisionCases[key] = modifiedTask.decisionCases[key].map(addIsSubWF);
        });
      }
  
      ["defaultCase", "loopOver", "forkTasks"].forEach((key) => {
        if (modifiedTask[key]) {
          modifiedTask[key] = modifiedTask[key].map(addIsSubWF);
        }
      });
  
      if (modifiedTask.forkTasks) {
        modifiedTask.forkTasks = modifiedTask.forkTasks.map((tasks) =>
          tasks.map(addIsSubWF)
        );
      }
  
      return modifiedTask;
    };
  
    const findTaskIndex = (tasks, taskReferenceName) => {
      for (let i = 0; i < tasks.length; i++) {
        if (tasks[i].taskReferenceName === taskReferenceName) {
          return [i];
        }
  
        if (tasks[i].decisionCases) {
          for (const key in tasks[i].decisionCases) {
            const decisionIndex = findTaskIndex(tasks[i].decisionCases[key], taskReferenceName);
            if (decisionIndex) {
              return [i, "decisionCases", key, ...decisionIndex];
            }
          }
        }
  
        if (tasks[i].defaultCase) {
          const defaultIndex = findTaskIndex(tasks[i].defaultCase, taskReferenceName);
          if (defaultIndex) {
            return [i, "defaultCase", ...defaultIndex];
          }
        }
  
        if (tasks[i].loopOver) {
          const loopOverIndex = findTaskIndex(tasks[i].loopOver, taskReferenceName);
          if (loopOverIndex) {
            return [i, "loopOver", ...loopOverIndex];
          }
        }
  
        if (tasks[i].forkTasks) {
          for (let j = 0; j < tasks[i].forkTasks.length; j++) {
            const forkIndex = findTaskIndex(tasks[i].forkTasks[j], taskReferenceName);
            if (forkIndex) {
              return [i, "forkTasks", j, ...forkIndex];
            }
          }
        }
      }
  
      return null;
    };
  
    const exp = !isExpanded;
  
    if (exp) {
      
      const wf = JSON.parse(JSON.stringify(wfData))
      // const wf = wfData.find((e) => e.name === vals.wfName);
 
      if (wf) {
        const wfTasks = wf.tasks;
        const indexPath = findTaskIndex(tasks, vals.taskReferenceName);

        const randomText = generateRandomText();
  
        const startWFTask = {
          asyncComplete: false,
          displayName: "START SUB WORKFLOW",
          hideTask: false,
          inputParameters: {},
          name: "LABEL_START_SUB_WORKFLOW",
          optional: false,
          taskReferenceName: `LABEL_START_SUB_WORKFLOW_${randomText}_ref`,
          type: "LABEL",
          isSubWF: true,
        };
  
        const endWFTask = {
          asyncComplete: false,
          displayName: "END SUB WORKFLOW",
          hideTask: false,
          inputParameters: {},
          name: "LABEL_END_SUB_WORKFLOW",
          optional: false,
          taskReferenceName: `LABEL_END_SUB_WORKFLOW_${randomText}_ref`,
          type: "LABEL",
        };
  
        if (indexPath) {
          let modifiedTasks = [...tasks];
          let currentTasks = modifiedTasks;
          var previousTask;
          var index;
          if (vals.type === TaskType.SubWorkflow) {
            let parentTask = currentTasks[indexPath[0] - 1];
  
            for (let i = 0; i < indexPath.length - 1; i++) {
              currentTasks = currentTasks[indexPath[i]];
            }
  
            index = indexPath[indexPath.length - 1];
            previousTask = { ...currentTasks[index], isSubWF: true };
  
            setExpandedSubWf({
              task: [...tasks],
              index: index,
              length: wfTasks.length,
            });
  
            currentTasks.splice(
              index,
              1,
              previousTask,
              startWFTask,
              ...wfTasks.map(addIsSubWF),
              endWFTask
            );
  
            setTasks(modifiedTasks);
          }
        }
      }
    } else {
      const { task } = expandedSubWf;
  
      // setOriginalTasks();
      setOriginalTasks(vals);
  
      setExpandedSubWf({
        task: null,
        index: null,
        length: null,
      });
    }
  
    setIsExpanded(exp);
  };
  

  const setOriginalTasks = (vals) => {
    const removeIsSubWFRecursively = (tasks) => {
      if (!Array.isArray(tasks)) {
        return []; // Return an empty array if tasks is not an array
      }

      return tasks
        .filter((task) => task && !(task.isSubWF && task.type !== "SUB_WORKFLOW")) // Keep tasks that are not isSubWF or are SUB_WORKFLOW
        .filter((task) => task && task.name !== "LABEL_END_SUB_WORKFLOW") // Filter out LABEL_END_SUB_WORKFLOW
        .map((task) => {
          let newTask = JSON.parse(JSON.stringify(task)); // Deep clone task
  // Remove isSubWF flag
          if (newTask.isSubWF) {
            delete newTask.isSubWF;
          }
  // Recursively process decisionCases
          if (newTask.decisionCases) {
            newTask.decisionCases = Object.fromEntries(
              Object.entries(newTask.decisionCases).map(([key, value]) => [
                key,
                removeIsSubWFRecursively(value),
              ])
            );
          }
  // Recursively process defaultCase
          if (newTask.defaultCase) {
            newTask.defaultCase = removeIsSubWFRecursively(newTask.defaultCase);
          }
   // Recursively process loopOver
          if (newTask.loopOver) {
            newTask.loopOver = removeIsSubWFRecursively(newTask.loopOver);
          }
 // Recursively process forkTasks
          if (newTask.forkTasks) {
            newTask.forkTasks = newTask.forkTasks.map((forkPath) =>
              removeIsSubWFRecursively(forkPath)
            );
          }

          return newTask;
        });
    };
    setTasks((prevTasks) => {
      // console.log("Latest tasks", prevTasks); //  up-to-date
  

   // Ensure tasks is an array before processing
      if (!Array.isArray(prevTasks)) {
        console.error("prevTasks is not an array:", prevTasks);
        return prevTasks; // Return previous state if invalid
      }
   // Process the tasks deeply
      let originalTasks = removeIsSubWFRecursively(prevTasks);
   // Find the task to modify
      const index = originalTasks.findIndex(
        (e) => e && e.taskReferenceName === vals.taskReferenceName
      );
     // If found, remove the isSubWF flag from the specific task
      if (index !== -1) {
        originalTasks[index] = { ...originalTasks[index] };
        delete originalTasks[index].isSubWF;
      }
  
      // console.log("Updated tasks:", originalTasks);
      return originalTasks; // Return the updated tasks state
    });
  
    setIsExpanded(false);
  };
  
  

  useEffect(() => {
    setIsExpanded(false);
  }, []);

  const handleChangedJQ = useCallback((status, editorId, val) => {
    onModifiedJQ(status);
    // var validJson = false;
    // if (editorId === "valueParamEditor" && val != "") {
    //   try {
    //     validJson = JSON.parse(val);
    //   } catch (error) {
    //     console.log("error: ", error);
    //     handleJsonInvalid(error);
    //   }
    // }
  });

  const handleJsonInvalid = (errors) => {
    onJsonErrors(errors);
  };

  const handleTaskData = (currentTaskData, prevTaskData) => {
    if (!isComponentLoading)
      if (!_.isEqual(currentTaskData, prevTaskData)) {
        setIsTaskDataLoading(true);

        if (!customTaskNotFound) {
          const updatedList = updateTaskList(
            tasks,
            currentTaskData,
            prevTaskData
          );
          // console.log(updatedList, currentTaskData, prevTaskData);
          setTasks(updatedList);
          // also update the clicked task data
          setTaskData(currentTaskData);
        }
        setIsTaskDataLoading(false);
      }
  };

  const setComponentLoadingState = (val) => {
    setIsComponentLoading(val);
    setIsNodeOnClickEnabled(val);
    setIsTaskDataLoading(val);
  };
  const handleOptionChange = (e, val) => {
    changeTask(val, taskData);
  };
  useEffect(() => {
    if (clickedWorkflowNodeTaskRef && tasks.length) {
      // clicked node ref

      const node = clickedWorkflowNodeTaskRef;
      const clickedTaskObj = getTaskObj(tasks, node);
      setComponentToRender(null);
      setClickedTask(clickedTaskObj);
      setTaskData(clickedTaskObj);
    } else if (taskData && !getTaskObj(tasks, taskData.taskReferenceName)) {
      setComponentToRender(null);
      setClickedTask(null);
      setTaskData(null);
    }
  }, [clickedWorkflowNodeTaskRef, tasks]);
  useEffect(() => {
    (async () => {
      if (clickedTask) {
        setComponentLoadingState(true);
        setCustomTaskNotFound(false);
        let Component = null;
        var taskType = taskArrayForSelectListing.length
          ? _.find(taskArrayForSelectListing, { task: clickedTask.type })
          : "";
        var systemOrCustom = taskType?.type;
        if (clickedTask.type === TaskType.FetchApproval) {
          systemOrCustom = "CUSTOM";
          taskType = clickedTask;
        }
        switch (systemOrCustom) {
          case "CUSTOM":
            Component = lazy(() =>
              import(`../../components/forms/tasks/CUSTOMTask`)
            );
            // setIsComponentLoading(false);
            try {
              const resp = await getTaskInputs(clickedTask.type);
              if (resp.status === 200) {
                var { data } = resp;
                var newData = data
                  ? data.filter(
                      (obj) => !("active" in obj) || obj.active === "True"
                    )
                  : [];

                // var newobs=  objects.filter(obj => obj.active === "True" && obj.hide === "False");

                // // Output the filtered objects
                // console.log(newobs);

                // data.forEach((field) => {
                //   // Check if the field is mandatory
                //   if (field.isMandatory === "Yes") {
                //     // Append '*' to the label
                //     field.fieldLabel += " *";
                //   }
                // });
                setInputFields(newData);
                setClickedTaskType(taskType);
              }
            } catch (error) {
              setInputFields([]);
              setClickedTaskType(taskType);
              setCustomTaskNotFound(true);
            }
            break;

          case "SYSTEM":
            setTimeout(async () => {
              Component = lazy(() =>
                import(
                  `../../components/forms/tasks/${clickedTask.type}Task`
                ).catch(() => ({
                  default: () => (
                    <ErrorBoundary>
                      <div>Module Does Not exist</div>
                    </ErrorBoundary>
                  ),
                }))
              );
              setComponentLoadingState(false);
              if (Component) {
                setComponentToRender(Component);
                setClickedWorkflowNodeTaskRef(null);
                setClickedTask("");
              }
            }, 500);
            return; // Exit early to prevent further execution
          default:
            break;
        }
        if (Component) {
          setComponentToRender(Component);
          setComponentLoadingState(false);
          setClickedWorkflowNodeTaskRef(null);
          setClickedTask("");
        }
      }
    })();
    // return () => {
    //   setComponentToRender(null);
    // };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedTask, inputParameters, taskArrayForSelectListing]);

  // useEffect(()=>{
  //   console.log('use called');
  // },[handleOptionChange])
  // useEffect(() => {
  //   const timer = setTimeout(() => {
  //     (async () => {
  //       if (clickedTask) {
  //         setIsComponentLoading(true);
  //         let Component = null;
  //         const taskType = taskArrayForSelectListing.length
  //           ? _.find(taskArrayForSelectListing, { task: clickedTask.type })
  //           : "";

  //         switch (taskType?.type) {
  //           case "CUSTOM":
  //             Component = lazy(() =>
  //               import(`../../components/forms/tasks/CUSTOMTask`)
  //             );
  //             setIsComponentLoading(false);
  //             try {
  //               const resp = await getTaskInputs(clickedTask.type);
  //               if (resp.status === 200) {
  //                 const { data } = resp;
  //                 setInputFields(data);
  //                 setClickedTaskType(taskType);
  //               }
  //             } catch (error) {
  //               console.log(error.response);
  //             }
  //             break;
  //           case "SYSTEM":
  //             Component = lazy(() =>
  //               import(`../../components/forms/tasks/${clickedTask.type}Task`).catch(
  //                 () => ({
  //                   default: () => (
  //                     <ErrorBoundary>
  //                       <div>Module Does Not exist</div>
  //                     </ErrorBoundary>
  //                   ),
  //                 })
  //               )
  //             );

  //             setIsComponentLoading(false);
  //             break;
  //           default:
  //             break;
  //         }

  //         if (Component) {
  //           setComponentToRender(Component);
  //           setClickedWorkflowNodeTaskRef(null);
  //           setClickedTask("");
  //         }
  //       }
  //     })();
  //   }, 5000); // 5 seconds delay

  //   // Clear the timeout if the component unmounts or the dependencies change
  //   return () => clearTimeout(timer);
  // }, [clickedTask, inputParameters, taskArrayForSelectListing]);

  useEffect(() => {
    (async () => {
      try {
        const resp = await getTasksListing();
        const { data } = resp;
        setTaskArrayForSelectListing(data);
      } catch (error) {
        if (error.response) console.error(error.response);
      }
    })();

    return () => {};
  }, []);
  // useEffect(() => {
  //   console.log('fileNotFound:', fileNotFound);
  // }, [fileNotFound]);

  return (
    <div className={tabClass.container} id={id}>
      {/* <Autocomplete
        id="select-tasks"
        options={taskArrayForSelectListing || []}
        ////////
        // for local
        // options={TASK_OPTIONS || []}
        ////////

        getOptionLabel={(option) => option?.task ?? option}
        // onChange={()=>{}}
        onChange={(e, newVal) => handleOptionChange(e, newVal)}
        renderInput={(params) => (
          <TextField {...params} label="Change Task Type" variant="outlined" />
        )}
      /> */}
      {/* <Snackbar
        open={fileNotFound}
        onClose={() => setFileNotFound(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        transitionDuration={{ exit: 0 }}
      >
        <Alert   onClose={() => setFileNotFound(false)} severity="error">
          File Not found
        </Alert>
      </Snackbar> */}
      <div className={tabClass.formContainer}>
        <Suspense fallback={<div>Loading...</div>}>
          {/* <Suspense fallback={isComponentLoading ? <div>Loading...</div> : ""}> */}
          {ComponentToRender ? (
            <>
              <div className={tabClass.header}>
                <Chip label={taskData?.type} />
                <Text
                  style={{
                    marginLeft: "8px",
                    fontSize: "13px",
                    fontFamily: "Poppins, Regular",
                    color: "#5C6366",
                  }}>
                  SETTINGS
                </Text>
              </div>

              {!customTaskNotFound && (
                <ComponentToRender
                  handleTaskData={handleTaskData}
                  allTasksData={tasks}
                  data={taskData}
                  forkTasks={taskData?.forkTasks ?? []}
                  inputParameters={inputParameters}
                  // // send the custom input fields via props
                  // // to dynamically create the ui of custom tasks
                  inputFields={
                    clickedTaskType.type === "CUSTOM" ||
                    clickedTaskType.type === TaskType.FetchApproval
                      ? inputFields
                        ? inputFields
                        : []
                      : []
                  }
                  // inputFields={inputFields || []}
                  customTaskName={
                    clickedTaskType?.type === "CUSTOM"
                      ? clickedTaskType?.task
                      : null
                  }
                  customTaskNotFound={customTaskNotFound}
                  onChangeJQ={handleChangedJQ}
                  onJsonInvalid={handleJsonInvalid}
                  setEditorDelay={setEditorDelay}
                  handleExpandChange={handleExpandChange}
                  isExpanded={isExpanded}
                  setIsExpanded={setIsExpanded}
                  setOriginalTasks={setOriginalTasks}
                />
              )}
              {customTaskNotFound && <div>Module Does Not exist</div>}
            </>
          ) : isComponentLoading ? (
            <div>Loading...</div>
          ) : (
            <div style={{ textAlign: "center" }}> No Task Selected.</div>
          )}
        </Suspense>
        {/* {accordians} */}
      </div>
    </div>
  );
};

export default TaskDefinationTab;
